import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {editCompanias, getCompanias, editCompaniasParametros} from '../../services';
import {ICompania, ICompaniasParametros, ICompaniaState} from "../types/ICompania";
import {AppState} from "./rootReducer";
import {ID_TOKEN_KEY} from "../../services/auth";
import {imageUrlToBase64} from "../../helpers";
const initialState: ICompaniaState = {
    status: "idle",
    data: {},
}

export const mostrarCompanias = createAsyncThunk(
    'mostrarCompanias', async () => {
        const response = await getCompanias()
        let data = response.data as ICompania;

        if(data?.logo) {
            try {
                const base64 = await imageUrlToBase64(data.logo);
                data = {
                    ...data,
                    logo: base64 as string
                }
            } catch (e) {
                console.error('Error al convertir el logo a base64', e);
                data = {
                    ...data,
                    logo: ''
                }
            }
        }


        return {data}
    }
)
export const mostrarCompaniaDatosSinoEsta = createAsyncThunk(
    'mostrarCompaniaDatosSinoEsta', async (_,thunkAPI) => {
        let companias = (thunkAPI.getState() as AppState)?.companias;
        if (Object.keys(companias?.data??{}).length || companias.status === "loading") return false;


        return thunkAPI.dispatch(mostrarCompanias());

    }
)
export const editarCompania = createAsyncThunk(
    'compania/agregarEditar', async (compania: ICompania) => {
        const response = await editCompanias(compania);
        //    if (response.status === 200) historyHelper.back();
        return {data: response.data};
    }
);
export const editarCompaniaParams = createAsyncThunk(
    'compania/eitarParams', async (param: ICompaniasParametros) => {
        await editCompaniasParametros(param);
        return {data: param};
    }
);



const slice = createSlice({
    name: 'mostrarCompanias',
    initialState,
    reducers: {
        setCompania(state,action: PayloadAction<ICompania>) {
            state.data = {...state.data,...action.payload};
        },
    },
    extraReducers: builder => {
        //---mostrarCompanias
        builder.addCase(mostrarCompanias.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarCompanias.fulfilled, (state,action ) => {
            state.status = "idle";
            const { data } = action.payload


            state.data = data;


        })
        builder.addCase(mostrarCompanias.rejected, (state ) => {
            state.status = "idle";
        })

        //--editarCompania
        builder.addCase(editarCompania.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(editarCompania.fulfilled, (state,action ) => {
            const { data } = action.payload;

            localStorage.setItem(ID_TOKEN_KEY, data.token);

            state.status = "idle";
            state.data = data;
        })
        builder.addCase(editarCompania.rejected, (state ) => {
            state.status = "idle";
        })

        //--editarCompaniaParams
        builder.addCase(editarCompaniaParams.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(editarCompaniaParams.fulfilled, (state,action ) => {
            const { data } = action.payload;
            state.status = "idle";

            let parametros = [...(state.data?.parametros ?? [])];
            if(data.activo){
                parametros.push(data);
            }else{
                parametros = parametros.filter(p => p.parametro !== data.parametro)
            }
            state.data = {
                ...state.data,
                parametros,
            }
        })
        builder.addCase(editarCompaniaParams.rejected, (state ) => {
            state.status = "idle";
        })

    }

});



export const {setCompania} = slice.actions;
export default slice.reducer;
